"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getManagerFunctions = void 0;
const globalEventBus_1 = require("../../eventBus/globalEventBus");
const types_1 = require("../../authoriser/types");
const getManagerFunctions = (Session, Authenticator = null, actionsCallBack) => {
    return {
        setAgentClientData: () => {
            actionsCallBack?.setAgentClientData?.();
            return undefined;
        },
        refreshAgentToken: agentToken => {
            const sessionData = Session.getData();
            Session.updateData({ ...sessionData, agentToken });
            actionsCallBack?.refreshAgentToken?.(agentToken);
        },
        invalidateSessionTokens: () => {
            actionsCallBack?.invalidateSessionTokens?.();
            return undefined;
        },
        refreshSessionTokens: (accessToken, refreshToken) => {
            const sessionData = Session.getData();
            actionsCallBack?.refreshSessionTokens?.(accessToken, refreshToken);
            Session.updateData({ ...sessionData, accessToken, refreshToken });
            Session.refresh();
        },
        notifyInteractionEnded: () => {
            Authenticator && Authenticator.logout();
            actionsCallBack?.notifyInteractionEnded?.();
        },
        RaiseN2InIvrSuccess: () => {
            actionsCallBack?.RaiseN2InIvrSuccess?.();
            return undefined;
        },
        RaiseN2InIvrFailure: () => {
            actionsCallBack?.RaiseN2InIvrFailure?.();
            return undefined;
        },
        RaiseN2OTPInIvrSuccess: progressId => {
            actionsCallBack?.RaiseN2OTPInIvrSuccess?.(progressId);
            (0, globalEventBus_1.publishRaiseN2OTPIVRSuccessEvent)({ type: types_1.ChallengeType.NONE, progressId });
        },
        RaiseN2OTPInIvrFailure: (errorType) => {
            actionsCallBack?.RaiseN2OTPInIvrFailure?.(errorType);
            (0, globalEventBus_1.publishRaiseN2OTPIVRErrorEvent)(errorType);
        },
        verifyDataInIvrSuccess: () => {
            (0, globalEventBus_1.publishVerifyDataInIvrSuccessEvent)(undefined);
            actionsCallBack?.verifyDataInIvrSuccess?.();
        },
        verifyDataInIvrFailure: (errorType) => {
            (0, globalEventBus_1.publishVerifyDataInIvrFailureEvent)(errorType);
            actionsCallBack?.verifyDataInIvrFailure?.(errorType);
        },
        updateSignatureKeySuccess: () => {
            actionsCallBack?.updateSignatureKeySuccess?.();
            return undefined;
        },
        updateSignatureKeyFailure: () => {
            actionsCallBack?.updateSignatureKeyFailure?.();
            return undefined;
        },
        createPasswordOnboardingFinished: () => {
            actionsCallBack?.createPasswordOnboardingFinished?.();
            return undefined;
        },
    };
};
exports.getManagerFunctions = getManagerFunctions;
//# sourceMappingURL=managerFunctions.js.map